import React from "react"

import "./style.scss"

export function Rating(props) {
  const { rating, isAuthenticated, userAccess } = props
  const value = rating.value || "N/A"
  const hasAccess = isAuthenticated && userAccess === "FULL"

  return (
    <div className="vendor-rating">
      <span className="vendor-rating-date">{rating.timeframe}</span>
      <p
        className="vendor-rating-value"
        data-isauthorized={hasAccess}
        data-cy="vendor-rating"
      >
        {formatRating(value)}
      </p>
    </div>
  )
}

const formatRating = (rating) => {
  if (!rating) {
    return null
  }

  rating = rating.toLowerCase()
  const ratingParts = rating.split("-")

  if (rating === "positive-to-neutral" || rating === "neutral-to-negative") {
    return (
      <>
        <span data-value={ratingParts[0]}>{ratingParts[0]}</span>
        <span>-{ratingParts[1]}-</span>
        <span data-value={ratingParts[2]}>{ratingParts[2]}</span>
      </>
    )
  } else if (rating === "negative" || rating === "positive") {
    return <span data-value={ratingParts[0]}>{ratingParts[0]}</span>
  } else {
    return <span data-value={"neutral"}>{rating}</span>
  }
}

export function RatingsPanel(props) {
  const { children } = props
  return (
    <ul className="vendor-rating-list">
      {React.Children.toArray(children).map((component, index) => {
        return (
          <li className="vendor-rating-item" key={index}>
            {component}
          </li>
        )
      })}
    </ul>
  )
}
